import { useCurrentClientId } from "hooks/api/use-clients";
import { useCurrentCampaignId } from "hooks/api/use-campaigns";

/**
 * Hook to get the current clientId and campaignId from React Query context.
 */
export const useApiContext = () => {
  const clientId = useCurrentClientId();
  const campaignId = useCurrentCampaignId();

  return {
    clientId,
    campaignId,
  };
};

/**
 * Hook to get the current clientId and campaignId.
 * Throws an error if they are not available in React Query context.
 * Use this in pages/components where client and campaign are guaranteed to be loaded.
 */
export const useRequiredApiContext = () => {
  const { clientId, campaignId } = useApiContext();

  if (!clientId || !campaignId) {
    throw new Error(
      "API context missing: clientId or campaignId is undefined. " +
        "Make sure this hook is used within a context where client and campaign are already loaded.",
    );
  }

  return {
    clientId,
    campaignId,
  };
};
